import { errorManagerInstance } from '../utils/errorManager';
import { EventBusEvent } from './event-bus-events';
export class EventBus {
    static instance_;
    static getInstance() {
        if (!EventBus.instance_) {
            EventBus.instance_ = new EventBus();
        }
        return EventBus.instance_;
    }
    events = {
        altCanvasResize: [],
    };
    methods = {
        altCanvasResize: () => this.events.altCanvasResize.some((cb) => cb.cb()),
    };
    emit(event, ...args) {
        this.verifyEvent_(event);
        this.events[event].forEach((cb) => cb.cb(...args));
    }
    /**
     * Registers a callback function for a specific event.
     * @param {EventBusEvent} params.event - The name of the event to register the callback for.
     * @param {string} params.cbName - The name of the callback function.
     * @param params.cb - The callback function to register.
     * @throws An error if the event is invalid.
     */
    on(event, cb) {
        this.verifyEvent_(event);
        // Add the callback
        this.events[event].push({
            cb,
            event: null,
        });
    }
    /** If the callback does not exist, create it */
    verifyEvent_(event) {
        if (typeof this.events[event] === 'undefined') {
            this.events[event] = [];
        }
    }
    /**
     * Registers a callback function for a specific event that will be called only once.
     * @param {EventBusEvent} params.event - The name of the event to register the callback for.
     * @param {string} params.cbName - The name of the callback function.
     * @param params.cb - The callback function to register.
     */
    once(event, cb) {
        this.verifyEvent_(event);
        // Add the callback
        this.events[event].push({
            cb: (...args) => {
                cb(...args);
                // if this.unregister is not null
                if (this.events[event]) {
                    // Remove the callback after it has been called once
                    this.unregister(event, cb);
                }
                else {
                    errorManagerInstance.log(`Callback for event ${event} was not found in unregister.`);
                }
            },
            event: null,
        });
    }
    unregister(event, cb) {
        for (let i = 0; i < this.events[event].length; i++) {
            if (this.events[event][i].cb === cb) {
                this.events[event].splice(i, 1);
                return;
            }
        }
        // If we got this far, it means we couldn't find the callback
        errorManagerInstance.log(`Callback for event ${event} was not found in unregister.`);
    }
    /**
     * Unregisters all events in the event bus. Used for testing.
     */
    unregisterAllEvents() {
        for (const event of Object.values(EventBusEvent)) {
            this.events[event] = [];
        }
    }
    init() {
        // Unused for now
    }
}
